import { useNavigate, useSearchParams } from 'react-router-dom';

import useCreateEntityLink from 'src/Components/EntityLinks/hooks/useCreateEntityLink';
import { getLinkedEntityRoute } from 'src/Components/EntityLinks/utils/entityLinkNavigation';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { LinkableEntityType } from 'src/Services/API/EntityLinks.api';

/**
 * Reads the `linkSourceType`/`linkSourceId` query params LinkEntityModal's "Créer une
 * nouvelle X" navigates with. If present, links the just-created entity back to that
 * source and navigates to the source's own fiche (rather than the usual close-to-list
 * behavior) so the user lands back where they started and sees the new link appear.
 * Falls back to `fallback()` (the wrapper's normal onClose/onCreate) when absent.
 */
const useLinkAfterCreate = (targetType: LinkableEntityType) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const assetId = useCurrentAssetId();
  const { mutate: createLink } = useCreateEntityLink();

  const linkSourceType = searchParams.get('linkSourceType') as LinkableEntityType | null;
  const linkSourceId = searchParams.get('linkSourceId');

  const handleCreated = (targetId: string | undefined, fallback: () => void): void => {
    if (!linkSourceType || !linkSourceId || !assetId || !targetId) {
      fallback();
      return;
    }

    createLink(
      { sourceType: linkSourceType, sourceId: linkSourceId, targetType, targetId },
      {
        onSettled: () => navigate(getLinkedEntityRoute(assetId, linkSourceType, linkSourceId)),
      }
    );
  };

  return { handleCreated };
};

export default useLinkAfterCreate;
